import { useState } from "react";

function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const reviewData = [
    {
      id: 1,
      name: "Sonali Londha",
      date: "2023-08-22",
      rating: 5,
      description: "Really one of the best cab service. Our cab driver was very humble, polite n punctual too. Would surely choose again.",
    },
    {
      id: 2,
      name: "Komal Singh",
      date: "2023-09-15",
      rating: 5,
      description: "Had a safe, comfortable ride while commuting from Pune to Mumbai. Drivers are polite, helpful. On time pick up and drop. Condition of the car is good, AC working condition.",
    },
    {
      id: 3,
      name: "Nazneen Patni",
      date: "2023-10-08",
      rating: 5,
      description: "Comfortable, neat and new vehicles! Professional, punctual and courteous driver. The entire transaction was smooth.",
    },
    {
      id: 4,
      name: "Aziz Awaradi",
      date: "2023-11-20",
      rating: 5,
      description: "I had an excellent experience with this cab service. The driver was extremely professional, polite, and friendly throughout the ride. The car was spotlessly clean, well-maintained, and had a fresh interior which made the journey very comfortable.",
    },
    {
      id: 5,
      name: "Ekta Raghuwanshi",
      date: "2023-12-05",
      rating: 5,
      description: "Amazing service. We were getting late for the railway station and these people really helped us reach on time. Highly recommend",
    },
    {
      id: 6,
      name: "Dwaipayan Chakravarty",
      date: "2024-01-12",
      rating: 4,
      description: "Mr. Shaikh himself took my parents in a brand new, we'll kept car after he couldn't find an allotted driver. The trip was nice. Very good for intercity travel",
    },
    {
      id: 7,
      name: "Anoop Kadne",
      date: "2024-02-18",
      rating: 5,
      description: "Had A pleasant experience with this xab service , the driver was professional also very patient , did not hurry and also came before time.. Would recommend to try their service once.. To experience professional services.",
    },
    {
      id: 8,
      name: "Pooja Awale",
      date: "2024-03-25",
      rating: 5,
      description: "Drivers are polite and respectful, cabs are also good, have experienced them, highly recommend",
    },
    {
      id: 9,
      name: "Tanveer Shaikh",
      date: "2024-04-10",
      rating: 5,
      description: "I had a great experience with this cab service. The driver was very polite and professional, arrived exactly on time, and the car was neat and clean. The ride was smooth, safe, and comfortable throughout the journey.",
    },
  ];

  const totalReviews = reviewData.length;
  const averageRating = reviewData.reduce((sum, review) => sum + review.rating, 0) / totalReviews;

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % reviewData.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + reviewData.length) % reviewData.length);
  };

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span
        key={index}
        className={`star ${index < rating ? "star-filled" : "star-outline"}`}
      >
        ★
      </span>
    ));
  };

  const currentReview = reviewData[currentIndex];

  return (
    <>
      <section className="testimonials-section">
        <div className="container">
          <div className="testimonials-content">
            <div className="testimonials-content__title">
              <h4>TESTIMONIALS</h4>
              <h2>What Clients Say About Us</h2>
            </div>

            <div className="testimonials-main">


              {/* Right Section - Testimonial Slider */}
              <div className="testimonials-slider">
                <button className="slider-arrow slider-arrow--prev" onClick={prevSlide}>
                  ‹
                </button>
                
                <div className="testimonial-card">
                  <div className="testimonial-card__header">
                    <div className="testimonial-card__user">
                      <div className="testimonial-card__avatar">
                        {getInitials(currentReview.name)}
                      </div>
                      <div className="testimonial-card__user-info">
                        <div className="testimonial-card__name">{currentReview.name}</div>
                        <div className="testimonial-card__date">{currentReview.date}</div>
                      </div>
                    </div>
                    <div className="testimonial-card__google-logo">
                      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                      </svg>
                    </div>
                  </div>
                  
                  <div className="testimonial-card__rating">
                    {renderStars(currentReview.rating)}
                  </div>
                  
                  <div className="testimonial-card__text">
                    {currentReview.description}
                  </div>
                </div>

                <button className="slider-arrow slider-arrow--next" onClick={nextSlide}>
                  ›
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonials;
